var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLbIconYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129.4 130.5",
    style: {
      enableBackground: "new 0 0 129.4 130.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFE500;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,122.1c0-1.2,0-2.1,0-3c0-28.2,0-56.5-0.1-84.7c0-2.1,0.7-3.3,2.4-4.4c10.4-6.8,20.7-13.7,31-20.5 c1.2-0.8,2.7-1.3,4.1-1.3c22.8-0.1,45.7-0.1,68.5-0.1c0.9,0,1.8,0,2.9,0c0,1.1,0,1.9,0,2.8c0,28.5,0,57,0,85.5 c0,1.6-0.4,2.7-1.9,3.6c-10.6,6.9-21.1,14-31.7,21c-1,0.7-2.4,1.2-3.7,1.2c-23.2,0.1-46.3,0.1-69.5,0 C11.9,122.3,11.2,122.2,10.2,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.9,76.9c0-11.9,0.1-23.8,0-35.7c0-2.2,0.6-2.9,2.8-2.8c7.7,0.1,15.5,0.1,23.2,0c2.4,0,2.9,0.8,2.9,3 c-0.1,18.2,0,36.3-0.1,54.5c0,2.4,0.7,3.1,3.1,3.1c8.6-0.1,17.2,0,25.7-0.1c2.2,0,3.1,0.4,3,2.9c-0.2,3.9-0.1,7.8,0,11.7 c0,1.6-0.4,2.4-2.2,2.4c-18.7-0.1-37.5-0.1-56.2,0c-2.1,0-2.2-1-2.2-2.6C17.9,101,17.9,88.9,17.9,76.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.8,53.4c7.5,2,10,5.3,10,12.6c0,5.2,0,10.5,0,15.7c0,6-3.9,10.2-9.9,10.3c-16.2,0.1-32.5,0-48.7,0.1 c-2.3,0-2-1.3-2-2.8c0-19.6,0-39.1,0-58.7c0-4.6,0.1-9.2,0-13.7c0-1.6,0.5-2.2,2.1-2.2c16.2,0.1,32.3,0,48.5,0.1 c6.2,0,10,4.2,10.1,10.4c0,5.5,0,11,0,16.5C113.7,48.7,111,52,103.8,53.4z M86.5,31.8c-1.7,0-3.4-0.1-5,0.1 c-0.5,0-1.2,0.7-1.2,1.1c-0.1,4-0.1,7.9-0.1,11.8c2.4,0,4.3,0,6.3,0C86.5,40.4,86.5,36.3,86.5,31.8z M80.2,62.2c0,3.4,0,6.6,0,9.8 s0,3.2,3.3,3.2c0.7,0,1.4,0.1,2-0.1c0.5-0.2,1.1-0.8,1.1-1.2c0.1-3.9,0.1-7.7,0.1-11.7C84.4,62.2,82.5,62.2,80.2,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5,31.8c0,4.5,0,8.6,0,13c-2,0-4,0-6.3,0c0-3.9,0-7.9,0.1-11.8c0-0.4,0.8-1.1,1.2-1.1C83.1,31.7,84.8,31.8,86.5,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2,62.2c2.3,0,4.2,0,6.5,0c0,4,0,7.9-0.1,11.7c0,0.4-0.7,1-1.1,1.2c-0.6,0.2-1.3,0.1-2,0.1c-3.3,0-3.3,0-3.3-3.2 S80.2,65.6,80.2,62.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLbIconYellow);
export default __webpack_public_path__ + "static/media/LB-Icon-yellow.ee93be8278e589fbc9fa5ea98d380d07.svg";
export { ForwardRef as ReactComponent };